
import { createContext, useState, useEffect } from "react";
import { getStatesWithHotels, getUserData } from "../services/api";

export const AllDataContext = createContext();
export const UserDataContext = createContext();

const loggedOutUser = { username: "", email: "", loggined: false };

export const ContextProvider = ({ children }) => {
    const [globalData, setGlobalData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(loggedOutUser);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await getUserData();
                setUser(result?.user ? { ...result.user, loggined: true } : loggedOutUser)
            } catch (err) {
                console.error("Error fetching user data:", err);
                setUser(loggedOutUser)
            } finally {
                setLoading(false);
            }
            try {
                const resultData = await getStatesWithHotels();
                setGlobalData(resultData);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };
        fetchData();
    }, []);
    return (
        <UserDataContext.Provider value={{ user, setUser, loading }} >
            <AllDataContext.Provider value={{ globalData, setGlobalData }}>
                {children}
            </AllDataContext.Provider>
        </UserDataContext.Provider>
    );
};
